import { ControlledTextFormField } from "@pimo/pimo-components/src/lib/pimo-components/pimo-form/controlled-fields/controlled-text-field";
import { FC, useEffect, useRef, useState } from "react";

export interface DraftTextFieldProps {
  value: string;
  onCommit: (value: string) => void;
  error?: boolean;
  helperText?: string;
  multiline?: boolean;
}

export const DraftTextField: FC<DraftTextFieldProps> = ({
  value,
  onCommit,
  error,
  helperText,
  multiline,
}) => {
  const [draft, setDraft] = useState(value);
  const lastExternal = useRef(value);
  useEffect(() => {
    if (value !== lastExternal.current) {
      lastExternal.current = value;
      setDraft(value);
    }
  }, [value]);

  return (
    <ControlledTextFormField
      value={draft}
      onChange={setDraft}
      onBlur={() => {
        if (draft !== value) {
          lastExternal.current = draft;
          onCommit(draft);
        }
      }}
      error={error}
      helperText={helperText}
      multiline={multiline}
    />
  );
};
